<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productosEditar"
  >
    <form
      autocomplete="off"
      class="m-container-primary"
      @submit.prevent="updateProducto"
    >
      <div class="row">
        <div class="column column-6">
          <!-- descripcion.nombre -->
          <AtomInputPrimary
            v-model="datos.descripcion.nombre"
            :inputError="$v.datos.descripcion.nombre.$error"
            :label="'Nombre'"
            :message="'* De 5 a 120 caracteres'"
            :messageError="messageErrorNombre"
            name="nombre"
            :placeholder="'Nombre del Producto'"
            type="text"
            @blur="$v.datos.descripcion.nombre.$touch()"
          />
        </div>
      </div>

      <div class="row">
        <div class="column column-6">
          <!-- descripcion.descripcion -->
          <AtomTextAreaPrimary
            v-model="datos.descripcion.descripcion"
            :inputError="$v.datos.descripcion.descripcion.$error"
            :label="'Descripción'"
            :message="'* De 10 a 120 caracteres'"
            :messageError="messageErrorDescripcion"
            name="descripcion"
            @blur="$v.datos.descripcion.descripcion.$touch()"
          />
        </div>
      </div>

      <div class="row">
        <div class="column column-6">
          <div class="m-card-record-info-licence">
            <div class="m-card-record-info-licence-body">
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.admins') }}
                <span class="font-size-xsmall text-color-black-45"> </span>
              </span>
                <span class="info-text-right">
                {{ datos.vidroop.administradores}}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.teachers') }}
                <span class="font-size-xsmall text-color-black-45"> </span>
              </span>
                <span class="info-text-right">
                {{ datos.vidroop.profesores }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                 {{ $t('mEditionBillingProductCreate.info.product.instructors') }}
                <span class="font-size-xsmall text-color-black-45"> </span>
              </span>
                <span class="info-text-right">
                {{ datos.vidroop.instructores}}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                 {{ $t('mEditionBillingProductCreate.info.product.students') }}
                <span class="font-size-xsmall text-color-black-45"> </span>
              </span>
                <span class="info-text-right">
                {{ datos.vidroop.alumnos }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.assets') }}
                <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingProductCreate.info.product.unlimited') }})</span>
              </span>
                <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.maps') }}
                <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingProductCreate.info.product.unlimited') }})</span>
              </span>
                <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.products') }}
                <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingProductCreate.info.product.unlimited') }})</span>
              </span>
                <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.salesData') }}
                <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingProductCreate.info.product.unlimited') }})</span>
              </span>
                <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.mails') }}
                <span class="font-size-xsmall text-color-black-45"></span>
              </span>
                <span class="info-text-right">
                 {{ datos.vidroop.emails }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
               {{ $t('mEditionBillingProductCreate.info.product.academy') }}
              </span>
                <span
                  v-if="datos.vidroop.tipo_universidad"
                  class="info-text-right"
                >
                {{ tipo_universidad[datos.vidroop.tipo_universidad].nombre }}
              </span>
                <span
                  v-else
                  class="info-text-right text-color-black-35">
                  {{ $t('mEditionBillingProductCreate.info.product.not') }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.integrations') }}
              </span>
                <span class="info-icon-right info-icon-billing">
              <i class="fas fa-check"></i>
            </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column column-12">
          <AtomButtonPrimary :button-primary="buttonPrimary"/>
        </div>
      </div>

      <div class="row margin-top-xxlarge">
        <div class="column column-12">
          <p class="font-size-small text-color-success font-weight-bold">
            <i class="far fa-info-circle"></i>
            INFO: Las características cantidad de productos, puntos de venta, proyectos y mapas comenzaron a ser ilimitadas para todas las licencias a partir del día 4/08/2024
          </p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { decimal, integer, maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionBillingProductsEdit',

  data () {
    return {
      productoId: '',

      buttonPrimary: {
        action: 'Guardar',
        class: 'a-button-billing-primary margin-top-xxlarge',
        sending: false,
        type: 'submit'
      },

      datos: {
        academia: {
          id: ''
        },

        descripcion: {
          nombre: '',
          descripcion: '',
          categoria: ''
        },

        vidroop: {
          alumnos: '',
          administradores: '',
          profesores: '',
          instructores: '',
          tipo_universidad: '',
          emails: '',
          comisiones: '',
          integraciones: 0,
          clases_vivo: 0,
          afiliaciones: 0,
          evaluaciones: 0,
          control_alumnos: 0,
          importacion_alumnos: 0
        }
      },

      datos_messageError: {
        descripcion: {
          nombre: {
            required: 'Nombre del producto es requerido.',
            maxLength: 'La longitud máxima permitida es de 120 caracteres.',
            minLength: 'La longitud mínima permitida es de 5 caracteres.'
          },
          descripcion: {
            required: 'La Descripcion del producto es requerido.',
            maxLength: 'La longitud máxima permitida es de 120 caracteres.',
            minLength: 'La longitud mínima permitida es de 10 caracteres.'
          },
          categoria: {
            required: 'La Categoria es requerida.'
          }
        },

        vidroop: {
          alumnos: {
            integer: 'El numero ingresado debe ser del tipo entero.',
            required: 'Cantidad de Alumnos es requerida.'
          },
          proyectos: {
            integer: 'El numero ingresado debe ser del tipo entero.',
            required: 'Cantidad de Proyectos es requerida.'
          },
          productos: {
            integer: 'El numero ingresado debe ser del tipo entero.',
            required: 'Cantidad de Productos es requerida.'
          },
          mapas: {
            integer: 'El numero ingresado debe ser del tipo entero.',
            required: 'Cantidad de Mapas de Aprendizaje es requerida.'
          },
          emails: {
            integer: 'El numero ingresado debe ser del tipo entero.',
            required: 'Cantidad de Lista de emails es requerida.'
          },
          puntos_venta: {
            integer: 'El numero ingresado debe ser del tipo entero.',
            required: 'Cantidad de Puntos de Venta es requerida.'
          },
          tipo_universidad: {
            required: 'Tipo de Universidad es requerido.'
          },
          comisiones: {
            decimal: 'El numero ingresado debe ser del tipo entero o decimal. Recuerde usar . en vez de , para el decimal',
            required: 'Comisiones es requerida.'
          }
        }
      },

      elementCategorias: [],

      tipo_universidad: [
        {
          id: 0,
          nombre: 'Mini'
        },

        {
          id: 1,
          nombre: 'Profesional'
        }
      ],

      showLoadingState: 0
    }
  },

  validations: {
    datos: {
      descripcion: {
        nombre: {
          maxLength: maxLength(120),
          minLength: minLength(5),
          required
        },
        descripcion: {
          maxLength: maxLength(120),
          minLength: minLength(10),
          required
        }
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.getmessageError(this.$v.datos.descripcion.nombre, 'descripcion', 'nombre')
    },

    messageErrorDescripcion () {
      return this.getmessageError(this.$v.datos.descripcion.descripcion, 'descripcion', 'descripcion')
    },
  },

  created () {
    this.productoId = this.$route.params.subid
    this.datos.academia.id = this.$store.getters.getAcademyData.id
    this.readProductoCategorias()
    this.readProductos()
  },

  methods: {
    getmessageError (fieldVState, field, childField) {
      if (fieldVState.$error) {
        let rules = this.datos_messageError[field][childField]
        for (const rule in rules) {
          if (!fieldVState[rule]) {
            return this.datos_messageError[field][childField][rule]
          }
        }
      }
    },

    readProductos () {
      this.$services.read('producto', 'readProducto', {}, [this.productoId])
        .then(response => {
          this.datos.descripcion.nombre = response.data.nombre
          this.datos.descripcion.descripcion = response.data.descripcion
          this.datos.descripcion.categoria = response.data.categoria ? response.data.categoria.id_producto_categoria : 1

          this.datos.vidroop.administradores = response.data.maximo_administradores
          this.datos.vidroop.profesores = response.data.maximo_profesores
          this.datos.vidroop.instructores = response.data.maximo_instructores
          this.datos.vidroop.alumnos = response.data.maximo_alumnos
          this.datos.vidroop.proyectos = response.data.maximo_proyectos
          this.datos.vidroop.productos = response.data.maximo_productos
          this.datos.vidroop.mapas = response.data.maximo_mapas
          this.datos.vidroop.emails = response.data.maximo_emails
          this.datos.vidroop.puntos_venta = response.data.maximo_puntos_venta
          this.datos.vidroop.tipo_universidad = response.data.tipo_universidad
          this.datos.vidroop.comisiones = response.data.comisiones
          this.datos.vidroop.integraciones = response.data.integraciones
          this.datos.vidroop.clases_vivo = response.data.clases_vivo
          this.datos.vidroop.afiliaciones = response.data.afiliaciones
          this.datos.vidroop.evaluaciones = response.data.evaluaciones
          this.datos.vidroop.control_alumnos = response.data.control_alumnos
          this.datos.vidroop.importacion_alumnos = response.data.importacion_alumnos

          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProductoCategorias () {
      this.$services.read('producto', 'readProductoCategorias')
        .then(response => {
          this.elementCategorias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    updateProducto () {
      this.$v.$touch()
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.update('producto', 'updateProducto', { producto: this.datos }, [this.productoId])
          .then(response => {
            this.$alerts.pushAlertNotTranslated('Los datos del producto fueron actualizados exitosamente.', 'a-alert-success')
            this.showLoadingState = 0
            this.readProductos()
            this.readProductoCategorias()
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlertNotTranslated('Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

  }
}
</script>
